import { render, staticRenderFns } from "./modalfollowers.vue?vue&type=template&id=428bf17c&scoped=true&"
import script from "./modalfollowers.vue?vue&type=script&lang=js&"
export * from "./modalfollowers.vue?vue&type=script&lang=js&"
import style0 from "./modalfollowers.vue?vue&type=style&index=0&id=428bf17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428bf17c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/buildhome/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VDialog,VDivider,VLayout})
